import(/* webpackMode: "eager", webpackExports: ["WelcomeRedirect"] */ "/vercel/path0/components/auth/WelcomeRedirect.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BroadcastVisitTracker"] */ "/vercel/path0/components/BroadcastVisitTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DomGuard"] */ "/vercel/path0/components/layout/DomGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HelpLauncherSlot"] */ "/vercel/path0/components/layout/HelpLauncherSlot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ImpersonationBanner"] */ "/vercel/path0/components/layout/ImpersonationBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RouteProgress"] */ "/vercel/path0/components/layout/RouteProgress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteLayout"] */ "/vercel/path0/components/layout/SiteLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SiteNoticeBar"] */ "/vercel/path0/components/layout/SiteNoticeBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThirdPartyTagsGate"] */ "/vercel/path0/components/layout/ThirdPartyTagsGate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetaPixelPageView"] */ "/vercel/path0/components/meta-pixel-page-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/components/providers/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralTracker"] */ "/vercel/path0/components/ReferralTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/root-document.tsx\",\"import\":\"Ubuntu\",\"arguments\":[{\"weight\":[\"400\",\"500\",\"700\"],\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":false,\"variable\":\"--font-ubuntu\"}],\"variableName\":\"ubuntu\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/local/target.css?{\"path\":\"app/root-document.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/taka.woff2\",\"weight\":\"400 700\",\"display\":\"swap\",\"preload\":false,\"adjustFontFallback\":false,\"declarations\":[{\"prop\":\"unicode-range\",\"value\":\"U+09F3\"}],\"variable\":\"--font-taka\"}],\"variableName\":\"taka\"}");
